/* 🤖 this file was generated by svg-to-ts */
export const matIconStop: {
  name: 'stop';
  data: string;
} = {
  name: 'stop',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 8v8H8V8h8m2-2H6v12h12V6z"/></svg>`
};
